module.exports = __webpack_public_path__ + "img/icon-instagram-farbig.535d36ea.svg";